<template>
	<div class="team">
        <v-dialog content-class="white" persistent v-model="progressLoad" max-width="80px">
            <v-progress-circular :size="50" indeterminate color="blue"></v-progress-circular>
        </v-dialog>
		<Header active="Teams"/>
		<TopSection heading="Teams" user="J K" :hideSearch=true />
        <v-dialog v-model="errorDialog" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <v-icon @click="$router.push(`/teams`)" class="white body-2 blue--text notification-close mr-1">close</v-icon>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">An error has occurred.</span>
            </div>
        </v-dialog>
        <v-dialog v-model="success" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <v-icon  @click="$router.push(`/teams`)" class="white body-2 blue--text notification-close mr-1">close</v-icon>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">Team successfully {{teamId ? deleted ? 'deleted' : 'edited' : 'created'}}</span>
            </div>
        </v-dialog>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-container class="pt-3" grid-list-lg>
                <v-layout>
                    <v-flex xs12 md8 xl5>
                        <div class="form-section">
                            <v-layout row wrap>
                                <v-flex md12>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Team name</span>
                                    </div>
                                    <v-text-field
                                        v-model="name"
                                        maxlength=100
                                        :counter="100"
                                        v-validate="'required'"
                                        data-vv-name="name"
                                        :error-messages="errors.collect('name')"
                                        solo
                                        flat
                                        height=66
                                        placeholder="Team Name"
                                        required
                                        class=" mb-1">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            
                        </div>
                        <div class="form-section">
                            <v-layout row wrap>
                                <v-flex md12>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Description</span>
                                    </div>
                                    <v-textarea
                                        v-model="description"
                                        maxlength=500
                                        flat
                                        solo
                                        :counter="500"
                                        rows=9
                                        no-resize
                                        placeholder="Descriptive text detailing the team"
                                        class=" mb-1">
                                    </v-textarea>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="form-section">
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md5>
                                    <v-btn @click="submit" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">{{teamId ? 'Edit' : 'Create'}} Team</span>
                                        <v-icon right class="white--text title">{{teamId ? 'save' : 'add'}}</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 md5>
                                    <v-btn @click="$router.go(-1)" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Cancel</span>
                                    </v-btn>
                                </v-flex>
                                <v-flex v-if="teamId" xs12 sm6 md5>
                                    <v-btn @click="dialog = true" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Delete</span>
                                        <v-icon right class="white--text title">delete</v-icon>
                                    </v-btn>
                                    <v-dialog v-model="dialog" persistent max-width="520">
                                        <div class="notification-heading standard-height blue pr-4">
                                            <v-icon @click="$router.push(`/teams`)" class="white body-2 blue--text notification-close mr-1">close</v-icon>
                                        </div>
                                        <v-card class="pt-4 pb-3">
                                            <v-card-title class="justify-center subtitle primary--text font-weight-bold">Do you really want to delete?</v-card-title>
                                            <v-card-actions>
                                                <v-btn class="white--text" color="grey lighten-1" grey @click="dialog = false">Cancel </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn class="white--text" color="grey lighten-1" grey @click="submit('delete')">Confirm</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-flex>
                            </v-layout> 
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
	</div>
</template>

<script>
    let colors = {
        hex: '#194d33',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
    }
    let color = {
        hex: '#fff'
    }
    let showColorPicker = false
    let imgPreviewSrc = {
        logo: '',
        background: ''
    }
    let filename = {
        logo: '',
        background: ''
    }

	import TopSection from '../components/TopSection.vue'
    import Header from '../components/Header.vue'
    import router from '../router'
    import teamService from '../services/team'
    import { globalStore } from '../main.js'
    import { Compact } from 'vue-color'
    import VeeValidate from 'vee-validate'
    import Vue from 'vue'

    Vue.use(VeeValidate);

	export default {
		name: 'App',
		components: {
            Header, TopSection,
            'compact-picker': Compact,
        },
         $_veeValidate: {
            validator: 'new'
        },
        mounted() {
            this.$validator.localize('en', this.dictionary)
        },
        data() {
            return {
                progressLoad: false,
                errorDialog: false,
                dialog: false,
                teamId: this.$route.params.id,
                companyId: sessionStorage.companyId,
                items: ['Light', 'Dark'],
                valid: true,
                name: '',
                success: false,
                dictionary: {
                    custom: {
                        name: {
                            required: () => 'Team name is required'
                        },
                    }
                },
                description: '',
                deleted: false,
            }
        },
        methods: {
            handleFileSelection(type) {
                this.filename[type] = event.target.files[0].name
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.imgPreviewSrc[type] = e.target.result
                }
                reader.readAsDataURL(event.target.files[0]);
            },
            uploadFile(e) {
                e.preventDefault()
            },
            handleRemoveFile(type) {
                this.$refs[type].value = ''
                this.imgPreviewSrc[type] = ''
                this.filename[type] = null
            },
            homeRedirect() {
                router.push('/teams')
            },
            async submit(event) {
                this.$validator.validate().then(result => {
                    if(result){
                        this.progressLoad = true;
                        if (this.teamId) {
                            if (event == 'delete') {
                                this.dialog = false;
                                teamService.delete(this.teamId)
                                    .then(res => {
                                        this.progressLoad = false;
                                        if (res.data.status == 1) {
                                            this.success = true;
                                            this.deleted = true;
                                        }
                                    }).catch(err => {
                                        this.progressLoad = false;
                                        this.errorDialog = true;
                                    });
                            } else {
                                teamService.update(this.teamId, {
                                    'name': this.name,
                                    'description': this.description,
                                }).then(res => {
                                    this.progressLoad = false;
                                    if (res.data.status == 1) {
                                        this.success = true;
                                    }
                                }).catch(err => {
                                    this.progressLoad = false;
                                    this.errorDialog = true;
                                });
                            }

                        } else {
                            teamService.create({
                                'name': this.name,
                                'description': this.description,
                                'companyId': this.companyId
                            }).then(res => {
                                this.progressLoad = false;
                                if (res.data.status == 1) {
                                    this.success = true;
                                }
                            }).catch(err => {
                                this.progressLoad = false;
                                this.errorDialog = true;
                            });
                        }
                    }
                });
            },
            async fetchData() {
                if (this.teamId) {
                    this.teamData = await teamService.fetchCompanyById(this.teamId);
                    this.description = this.teamData.data.description;
                    this.name = this.teamData.data.name;
                }
            }
        },
        created() {
            this.fetchData();
        }
	}

</script>